{
  "banner.close": "Stäng",
  "jasenedut.allCategories": "Alla förmåner",
  "jasenedut.cityFilterAll": "Alla städer",
  "jasenedut.cityFilterLabel": "Stad",
  "jasenedut.demoDisclosure": "Exempelinnehåll: dessa förmåner är demoexempel, inte riktiga partnerförmåner.",
  "jasenedut.empty": "Inga förmåner är tillgängliga.",
  "jasenedut.heading": "Förmåner och rabatter",
  "jasenedut.linkLabel": "Läs mer här",
  "jasenedut.linkNewTabHint": "(öppnas i en ny flik)",
  "jasenedut.showDetails": "Visa mer information",
  "login.disclaimer.demoIntent": "Den här vyn är endast avsedd för testning. Vanligtvis skulle stark autentisering användas här.",
  "login.heading": "Logga in",
  "analytics.consent.notice.accept": "Tillåt mätning",
  "analytics.consent.notice.body": "Genom att tillåta mätning av användningen hjälper du YTK att förstå vilka funktioner i Oma+ som används och hur tjänsten fungerar. Uppgifterna används för att utveckla tjänsten. I administratörernas rapporter visas sammanställningar, inte ditt namn eller medlemsnummer.\n\nMätningen kan koppla samman dina användningsuppgifter mellan besök och enheter. Mätningen är frivillig: du kan också använda Oma+ utan den och ändra ditt val när som helst i Mina uppgifter.",
  "analytics.consent.notice.failed": "Valet sparades inte. Mätningen förblir avstängd.",
  "analytics.consent.notice.dismiss": "Stäng mätningens val",
  "analytics.consent.notice.heading": "Hjälp oss utveckla Oma+",
  "analytics.consent.notice.refuse": "Tillåt inte mätning",
  "analytics.consent.notice.retry": "Försök igen",
  "analytics.consent.notice.saving": "Sparar…",
  "analytics.consent.notice.stale": "Valet ändrades på en annan enhet. Kontrollera det aktuella valet och välj igen.",
  "analytics.consent.profile.accepted": "Tillåten. Du kan när som helst återkalla mätningen av webbplatsanvändningen.",
  "analytics.consent.profile.currentChoice": "Aktuellt val",
  "analytics.consent.profile.disabled": "Mätningen är inte aktiverad.",
  "analytics.consent.profile.enable": "Tillåt mätning",
  "analytics.consent.profile.heading": "Hjälp oss utveckla Oma+",
  "analytics.consent.profile.retryWithdraw": "Försök återkalla tillståndet igen",
  "analytics.consent.profile.withdraw": "Återkalla tillståndet för mätning",
  "analytics.consent.notice.unavailable": "Mätningstillståndet kunde inte kontrolleras. Mätningen förblir avstängd.",
  "messages.empty": "Inga meddelanden",
  "messages.title": "Meddelanden",
  "myData.audit.count": "Logghändelser som gäller dig",
  "myData.audit.earliest": "Äldsta händelsen",
  "myData.audit.heading": "Händelselogg",
  "myData.analytics.active": "Aktiv användning",
  "myData.analytics.active.missing": "Aktiv användning uppmättes inte",
  "myData.analytics.attribution.unavailable": "Inte tillgänglig",
  "myData.analytics.campaignMedium": "Kampanjkanal",
  "myData.analytics.campaignName": "Kampanjnamn",
  "myData.analytics.campaignSource": "Kampanjkälla",
  "myData.analytics.device.desktop": "Dator",
  "myData.analytics.device.mobile": "Mobil enhet",
  "myData.analytics.device.tablet": "Surfplatta",
  "myData.analytics.device.unknown": "Okänd enhet",
  "myData.analytics.empty": "Inga uppgifter om webbplatsanvändning har sparats.",
  "myData.analytics.entryDevice": "Startenhet",
  "myData.analytics.entryLanguage": "Startspråk",
  "myData.analytics.entrySource": "Startkälla",
  "myData.analytics.error.render": "Renderingsfel",
  "myData.analytics.error.resourceLoad": "Resursladdningsfel",
  "myData.analytics.error.routeLoad": "Vyladdningsfel",
  "myData.analytics.error.unhandled": "Ohantterat fel",
  "myData.analytics.errors": "Felmätningsdata",
  "myData.analytics.errors.none": "Inga felmätningsdata registrerades",
  "myData.analytics.heading": "Uppgifter om webbplatsanvändning",
  "myData.analytics.language.en": "Engelska",
  "myData.analytics.language.fi": "Finska",
  "myData.analytics.language.sv": "Svenska",
  "myData.analytics.language.unknown": "Okänt språk",
  "myData.analytics.load.document": "Dokumentladdning",
  "myData.analytics.load.route": "Vyladdning",
  "myData.analytics.loadingNext": "Laddar nästa sida…",
  "myData.analytics.loads": "Laddningsmätningar",
  "myData.analytics.loads.none": "Inga laddningsmätningar registrerades",
  "myData.analytics.nextPage": "Visa nästa sida",
  "myData.analytics.occurredAt": "Tidpunkt",
  "myData.analytics.page": "Sida",
  "myData.analytics.pageError": "Det gick inte att ladda nästa sida. Försök igen.",
  "myData.analytics.quality": "Mätningens kvalitet",
  "myData.analytics.quality.measured": "Fullständig mätning",
  "myData.analytics.quality.partial": "Delvis mätning",
  "myData.analytics.quality.unavailable": "Mätningen är inte tillgänglig",
  "myData.analytics.referrerHost": "Hänvisande webbplats domännamn",
  "myData.analytics.retry": "Försök igen",
  "myData.analytics.source.direct": "Direkt besök",
  "myData.analytics.source.email": "E-post",
  "myData.analytics.source.paid": "Betald annonsering",
  "myData.analytics.source.referral": "Hänvisande webbplats",
  "myData.analytics.source.search": "Sökmotor",
  "myData.analytics.source.social": "Sociala medier",
  "myData.analytics.source.unknown": "Okänd källa",
  "myData.analytics.unavailable": "Uppgifter om webbplatsanvändning är inte tillgängliga just nu.",
  "myData.successfulMemberMessages.category.jasenasiat": "Medlemsärenden",
  "myData.successfulMemberMessages.category.lakikaveri": "Lakikaveri",
  "myData.successfulMemberMessages.empty": "Inga lyckade skickade meddelanden har sparats.",
  "myData.successfulMemberMessages.heading": "Lyckade skickade meddelanden",
  "myData.successfulMemberMessages.kind.initial": "Första kontakt",
  "myData.successfulMemberMessages.kind.reply": "Svar",
  "myData.successfulMemberMessages.loadingNext": "Laddar nästa sida…",
  "myData.successfulMemberMessages.messageKind": "Meddelandetyp",
  "myData.successfulMemberMessages.nextPage": "Visa nästa sida",
  "myData.successfulMemberMessages.occurredAt": "Tidpunkt",
  "myData.successfulMemberMessages.pageError": "Det gick inte att ladda nästa sida. Försök igen.",
  "myData.successfulMemberMessages.retry": "Försök igen",
  "myData.successfulMemberMessages.serviceCategory": "Tjänstekategori",
  "myData.successfulMemberMessages.unavailable": "Uppgifter om lyckade skickade meddelanden är inte tillgängliga just nu.",
  "myData.contactVerification.heading": "Kontroll av kontaktuppgifter",
  "myData.contactVerification.lastVerified": "Senast bekräftad",
  "myData.contactVerification.never": "Du har ännu inte bekräftat dina kontaktuppgifter.",
  "myData.languageSetting.heading": "Språkval",
  "myData.languageSetting.chosen": "Valt språk",
  "myData.languageSetting.never": "Du har inte valt något språk. Appen visas på finska.",
  "myData.languageSetting.language.en": "Engelska",
  "myData.languageSetting.language.fi": "Finska",
  "myData.languageSetting.language.sv": "Svenska",
  "myData.feedback.empty": "Du har inte gett någon respons.",
  "myData.feedback.heading": "Respons du har gett",
  "myData.feedback.rating": "Betyg",
  "myData.intro": "På den här sidan ser du samlat de uppgifter som applikationen lagrar om dig. För varje uppgiftsgrupp anges om uppgifterna hanteras i den här applikationen eller i en annan tjänst.",
  "myData.legacy.heading": "Uppgifter som hanteras i andra tjänster",
  "myData.legacy.messaging.note": "Dina meddelanden till YTK hanteras i OmaYTK-tjänsten. Applikationen visar dem därifrån och sparar ingen kopia av dem.",
  "myData.ownership.app": "Hanteras i den här applikationen",
  "myData.ownership.legacy": "Hanteras i en annan tjänst",
  "myData.profile.email": "E-post",
  "myData.profile.heading": "Profil",
  "myData.profile.memberNumber": "Medlemsnummer",
  "myData.profile.name": "Namn",
  "profile.admin.heading": "Administratör",
  "profile.back": "Tillbaka",
  "profile.certificate.download": "Ladda ner medlemsintyg",
  "profile.certificate.downloadError": "Det gick inte att ladda ner medlemsintyget. Försök igen.",
  "profile.certificate.downloaded": "Medlemsintyget har laddats ner.",
  "profile.certificate.downloading": "Medlemsintyget skapas…",
  "profile.certificate.feePaid": "Betald",
  "profile.certificate.feeUnpaid": "Obetald",
  "profile.certificate.feeStatus": "Medlemsavgiftens status",
  "profile.certificate.heading": "Medlemsintyg",
  "profile.certificate.issuedAt": "Datum",
  "profile.certificate.memberName": "Namn",
  "profile.certificate.memberNumber": "Medlemsnummer",
  "profile.certificate.startDate": "Medlemskapets startdatum",
  "profile.certificate.contactService": "Medlemsintyget kan inte skapas eftersom dina medlemsuppgifter är bristfälliga. Kontakta medlemstjänsten.",
  "profile.certificate.unavailable": "Medlemsintyget är inte tillgängligt just nu. Försök igen senare.",
  "profile.contact.email": "E-post",
  "profile.contact.heading": "Kontaktuppgifter",
  "profile.contact.phone": "Telefonnummer",
  "profile.contact.syncNotice": "Dina kontaktuppgifter uppdateras mellan YTK Työelämä och YTK Työttömyyskassa. Om du vill kan du hantera ditt samtycke till uppdatering av kontaktuppgifter i YTK Työttömyyskassas",
  "profile.contact.syncNoticeLink": "OmaYTK-tjänst",
  "profile.fee.account": "Kontonummer",
  "profile.fee.amount": "Belopp",
  "profile.fee.bank": "Bank",
  "profile.fee.billingMethod": "Faktureringssätt",
  "profile.fee.copyAccount": "Kopiera kontonummer",
  "profile.fee.copyReference": "Kopiera referensnummer",
  "profile.fee.dueDate": "Förfallodag",
  "profile.fee.empty": "Inga fakturor.",
  "profile.fee.eInvoice.guidance": "Du får för närvarande dina medlemsavgiftsfakturor som pappersfakturor. Du kan övergå till e-faktura, så kommer fakturorna direkt till din nätbank.",
  "profile.fee.eInvoice.methodPaper": "Pappersfaktura",
  "profile.fee.eInvoice.methodEInvoice": "E-faktura",
  "profile.fee.eInvoice.methodUnknown": "Ditt faktureringssätt kunde inte fastställas just nu.",
  "profile.fee.eInvoice.pending": "E-fakturaförslag beställt {date}\n\nVi skickade förslaget till din nätbank. Godkänn det i din nätbank, så ändras faktureringssättet till e-faktura. Du kan beställa ett nytt förslag tidigast {again}.",
  "profile.fee.eInvoice.unavailable": "Faktureringsuppgifterna kan inte hämtas just nu. Försök igen om en stund.",
  "profile.fee.eInvoice.submitting": "Skickar e-fakturaförslag…",
  "profile.fee.eInvoice.unconfirmed": "Vi kunde inte bekräfta beställningen av e-fakturaförslaget. Förslaget är sannolikt ändå på väg till din nätbank. Kontrollera din nätbank om några vardagar innan du beställer ett nytt förslag.",
  "profile.fee.eInvoice.errorAlreadyRequested": "Du har redan ett e-fakturaförslag under behandling. Godkänn det i din nätbank.",
  "profile.fee.eInvoice.errorUnsupportedBank": "Den bank du valde kan inte användas för e-fakturaförslag just nu. Välj en annan bank eller försök igen senare.",
  "profile.fee.eInvoice.errorRetryConflict": "Din tidigare beställning behandlas fortfarande. Försök igen om en stund.",
  "profile.fee.eInvoice.errorRefused": "E-fakturaförslaget kunde inte göras. Kontakta medlemstjänsten.",
  "profile.fee.eInvoice.errorUnavailable": "Beställningen av e-fakturaförslag lyckades inte just nu. Försök igen om en stund.",
  "profile.fee.eInvoice.cancel": "Avbryt",
  "profile.fee.eInvoice.confirmation": "Förslaget om e-faktura har skickats. Det syns i din nätbank inom 1–3 vardagar. Kom ihåg att godkänna det i din nätbank — faktureringssättet ändras till e-faktura först efter godkännandet.",
  "profile.fee.eInvoice.description": "När du beställer ett e-fakturaförslag skickar vi ett förslag om e-faktura för medlemsavgiften till din nätbank. Förslaget syns i din nätbank inom 1–3 vardagar beroende på bank.\n\nDu godkänner förslaget själv i din nätbank. Först efter godkännandet ändras faktureringssättet till e-faktura, och du får medlemsavgiftsfakturorna i fortsättningen direkt till din nätbank.\n\nVälj din bank och tryck på Beställ.",
  "profile.fee.eInvoice.request": "Beställ e-fakturaförslag",
  "profile.fee.eInvoice.placeholder": "Välj bank",
  "profile.fee.eInvoice.sessionExpired": "Din session har gått ut. Logga in igen och beställ e-fakturaförslaget därefter.",
  "profile.fee.eInvoice.selectBank": "Bank",
  "profile.fee.eInvoice.submit": "Beställ",
  "profile.fee.heading": "Medlemsavgift",
  "profile.fee.invoiceDate": "Fakturadatum",
  "profile.fee.invoiceNumber": "Fakturanummer",
  "profile.fee.payCta": "Gå till betalning",
  "profile.fee.paymentHistory": "Tidigare fakturor",
  "profile.fee.reference": "Referensnummer",
  "profile.fee.status": "Status",
  "profile.fee.statusPaid": "Betald",
  "profile.fee.statusUnavailable": "Betalningsstatus inte tillgänglig",
  "profile.fee.statusUnpaid": "Obetald",
  "profile.fee.unavailable": "Uppgifter om medlemsavgiften är inte tillgängliga just nu. Försök igen senare.",
  "profile.hub.certificate": "Medlemsintyg",
  "profile.hub.contact": "Mina kontaktuppgifter",
  "profile.hub.fee": "Medlemsavgift",
  "profile.hub.myData": "Sparade uppgifter",
  "profile.myData.unavailable": "Sparade uppgifter är inte tillgängliga just nu. Försök igen senare.",
  "profile.memberNumber.copyButton": "Kopiera medlemsnummer",
  "profile.memberNumber.copied": "Medlemsnummer kopierat",
  "profile.memberNumber.label": "Medlemsnummer",
  "profile.membershipSummary": "{tier} sedan {date}",
  "profile.membershipUnavailable": "Medlemsuppgifter är inte tillgängliga just nu.",
  "profile.title": "Mina uppgifter",
  "profile.unavailable": "Profiluppgifter är inte tillgängliga just nu. Försök igen senare.",
  "profile.verify.cancel": "Avbryt",
  "profile.verify.confirm": "Uppgifterna är aktuella",
  "profile.verify.emailSuggestions.label": "E-postförslag",
  "profile.verify.error.city": "Ange en ort.",
  "profile.verify.error.email": "Ange en giltig e-postadress.",
  "profile.verify.error.phone": "Ange ett telefonnummer.",
  "profile.verify.error.postalCode": "Ange ett femsiffrigt postnummer.",
  "profile.verify.error.street": "Ange en gatuadress.",
  "profile.verify.field.city": "Ort",
  "profile.verify.field.email": "E-post",
  "profile.verify.field.phone": "Telefonnummer",
  "profile.verify.field.postalCode": "Postnummer",
  "profile.verify.field.street": "Gatuadress",
  "profile.verify.intro": "Kontrollera att dina kontaktuppgifter är aktuella.",
  "profile.verify.save": "Spara",
  "profile.verify.saveError.validation": "Kontrollera de uppgifter du har angett och försök igen.",
  "profile.verify.saveError.conflict": "Dina uppgifter har ändrats. Kontrollera uppgifterna och försök igen.",
  "profile.verify.saveError.unavailable": "Det gick inte att spara just nu. Försök igen om en stund.",
  "profile.verify.saveError.notFound": "Dina medlemsuppgifter hittades inte. Kontakta kundtjänsten.",
  "profile.verify.saveSuccess": "Uppgifterna har sparats.",
  "profile.verify.startEdit": "Uppdatera uppgifter",
  "profile.verify.title": "Kontrollera dina kontaktuppgifter"
}
